import { ImageCell } from '@/components/shared/ImageCell';
import type { Attraction } from '@/config/objects/attractions';

interface AttractionImageCellProps {
  attraction?: Attraction;
  size?: 'sm' | 'lg';
}

/**
 * Editable attraction image cell component with upload and delete actions
 */
export function AttractionImageCell({ attraction, size = 'sm' }: AttractionImageCellProps) {
  return (
    <ImageCell
      item={attraction}
      endpoint="/attractions"
      entityName="Attraction"
      imageLabel="Attraction Image"
      getFeaturedImage={(item) => item.featuredImage}
      getItemId={(item) => item.id}
      size={size}
    />
  );
}
